module.exports = __webpack_public_path__ + "img/hz_34.e713a964.jpg";